// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y1BL","title":"styles_title__2UG8K"};